import { Order, OrderType } from './order';

interface MatchGroups {
  field?: string;
  order?: OrderType; // Restringe los valores posibles
}

export class SortHelper {
  static parse(value: string | undefined): Order[] {
    const rv: Order[] = [];
    if (typeof value === 'string' && value.length > 0) {
      const aux = value.split(',');
      const re = /(?<field>.*)\s+(?<order>(?:a|de)sc)/i;
      aux.forEach((item) => {
        const match = re.exec(item);

        // Validar y trabajar con los grupos
        if (match?.groups) {
          // Acceso seguro y tipado a los grupos
          const { field, order } = match.groups as MatchGroups;
          const orderBy: Order = {
            field: field?.trim() as string,
            type: order?.trim() as OrderType,
          };
          rv.push(orderBy);
        }
      });
    }

    return rv;
  }
}
